<template>
  <div>
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-navbar></layout-navbar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">

        <!-- Page Content -->
        <div class="content container-fluid">

          <div class="crms-title row bg-white">
            <div class="col  p-0">
              <h3 class="page-title m-0">
                        <span class="page-title-icon bg-gradient-primary text-white mr-2">
                          <i class="feather-grid"></i>
                        </span> TOMs </h3>
            </div>
            <div class="col p-0 text-right">
              <ul class="breadcrumb bg-white float-right m-0 pl-0 pr-0">
                <li class="breadcrumb-item"><router-link to="/index">DSMS</router-link></li>
                <li class="breadcrumb-item active">TOMs</li>
              </ul>
            </div>
          </div>

          <!-- Page Header -->
          <div class="page-header pt-3 mb-0 ">
            <div class="row">
              <div class="col-12 text-right">
                <ul class="list-inline-item pl-0">
                  <li class="list-inline-item">
                    <div class="dropdown">
                      <a class="dropdown-toggle recently-viewed" href="#" role="button" data-toggle="dropdown" aria-expanded="false">Spalte anzeigen</a>
                      <div class="dropdown-menu">
                        <a v-for="(column, index) in columns" class="dropdown-item dropdown-column-item" href="#" @click.prevent="toggle_column($event,index)"><i class="fa fa-check"></i> {{column}}</a>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item dropdown list-inline-item add-lists">
                    <a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                      <div class="nav-profile-text">
                        <i class="fa fa-th" aria-hidden="true"></i>
                      </div>
                    </a>
                    <div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Content Starts -->
          <DataTableDSMS
            title="TOMs Liste"
            fileName="TOMs"
            modelName="toms"
            deleteURL="todos/v1/delete_question/"
            :extraActions="extraActions"
            :columns="columns"
            :objects="toms_list"
            :exportColumns="[0, 1, 9]"
            :allowDelete="false"
            editorPatchURL=""
            @tableCreated="setTable"
            @editorCreated="setEditor"
            @showObject="showTOMs"
            @callDrawback="drawCallbackFunctions"
            v-if="toms_list.length > 0"
          ></DataTableDSMS>
          <!-- /Content End -->
          <modal width="80%" v-show="showConfirm" @close="showConfirm=false" v-if="organizedResult">
            <template v-slot:header><h4>Bitte die Prüfergebnisse bestätigen</h4></template>
            <template v-slot:body>
              <h4>Prüfbericht: DDK - TOMS Report</h4>
              <h4>{{account.name}}</h4>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Zutrittskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.zutrittskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.zutrittskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.zutrittskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.zutrittskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Zugangskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugangskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugangskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugangskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugangskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Zugriffskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Zugriffskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Zugriffskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Weitergabekontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle green"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Weitergabekontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Weitergabekontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Pseudonymisierung</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Pseudonymisierung.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Pseudonymisierung.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Pseudonymisierung.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Pseudonymisierung.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Trennungskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Trennungskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Trennungskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Trennungskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Trennungskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Eingabekontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Eingabekontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Eingabekontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Eingabekontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Eingabekontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Verfügbarkeitskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Verfuegbarkeitskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Verfuegbarkeitskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Auftragskontrolle</h4>
                </div>
                <h5>Vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.yes.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Auftragskontrolle.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Auftragskontrolle.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Auftragskontrolle.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Auftragskontrolle.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <div class="row" style="margin: 5px">
                  <h4 class="dialogtitle">Organisatorische Sicherheitskriterien</h4>
                </div>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.yes.length>0">
                  <h5>Vorhandene Maßnahmen</h5>
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Organisatorische.yes" :key="index">
                    <th>
                <span>
                  <i class="feather feather-check-circle igreen"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Teilweise vorhandene Maßnahmen</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.partial.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Organisatorische.partial" :key="index">
                    <th>
                <span>
                  <i class="feather feather-alert-circle warning"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
                <h5>Ausstehende Maßnahme (To-do)</h5>
                <table class="table table-bordered table-hover table-striped mb-4" v-if="organizedResult.Organisatorische.no.length>0">
                  <tr>
                    <td >Status</td>
                    <td>Maßnahme</td>
                    <td>Bemerkung</td>
                  </tr>
                  <tr v-for="(item, index) in organizedResult.Organisatorische.no" :key="index">
                    <th>
                <span>
                  <i class="feather feather-x-circle ired"></i>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.desc }}</p>
                </span>
                    </th>
                    <th>
                <span>
                  <p>{{ item.comment }}</p>
                </span>
                    </th>
                  </tr>
                </table>
              </div>
              <div><br></div>
              <div>
                <van-field
                  type="textarea"
                  :rows="2"
                  placeholder="Kommentar für den Bericht"
                  v-model="auditComment">
                </van-field>
                <!--<ckeditor :editor="editor" v-model="surveyComment" ></ckeditor>-->
              </div>
            </template>
            <template v-slot:footer>
              <button class="btn btn-outline-danger" @click="showConfirm=false">Schließen</button>
            </template>
          </modal>

        </div>
        <!-- /Page Content -->

      </div>
      <!-- /Page Wrapper -->
    </div>

  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import "survey-vue/defaultV2.css";
  import service from '@/utils/request.js';
  import { baseURL, pathSeparator } from '@/utils/request'
  import Modal from "@/components/component/Modal.vue";
  import { Field } from 'vant';
  import DataTableDSMS from "@/components/component/DataTableDSMS.vue";
  import {deepCopy} from "@/utils";
  import {organizedResult, objectModalName, newSystem} from "@/utils/enums";
  export default {
    components: {Modal, 'van-field': Field, DataTableDSMS},
    data() {
      return {
        showConfirm: false,
        organizedResult: organizedResult,
        auditComment: '',
        toms_list:[],
        columns: [
          {
            label: 'Nr.#',
            name: 'sequence',
            enableEditor: false,
            definition: {data: "sequence", width: '50px'},
          },
          {
            label: 'Name',
            name: 'name',
            enableEditor: false,
            definition: { data: "name", width: "15%", render: () => `${this.account.name} TOMs Bericht` },
          },
          {
            label: 'TOMs Bericht',
            name: 'report_url_toms',
            enableEditor: false,
            definition: { data: "report_url_toms", width: "20%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">TOMs Beschreibung</a></span>` : '' },
          },
          {
            label: 'Todo Liste',
            name: 'report_url_todos',
            enableEditor: false,
            definition: { data: "report_url_todos", width: "20%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Maßnahmen Liste</a></span>` : '' },
          },
          {
            label: 'TOMs Audit Bericht',
            name: 'report_url_audit',
            enableEditor: false,
            definition: { data: "report_url_audit", width: "20%", render: (data) => data ? `<span><a class="download-link" href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">Audit Bericht</a></span>` : '' },
          },
          {
            label: 'Stand',
            name: 'stand',
            enableEditor: false,
            definition: { data: "stand", width: "5%" },
          },
        ],
        table: null,
        editor: null
      }
    },
    created() {
    },
    computed: {...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id}), },
    mounted() {
      this.getTOMs()
    },
    updated ()
    {},
    methods: {
      setTable(table) {
        this.table = table
      },
      setEditor(editor) {
        this.editor = editor
      },
      showTOMs(objectID) {
        if (objectID == null) {
          this.$router.push('toms')
        } else {
          const content = this.toms_list.filter(item => item.id === objectID)[0].content || {}
          if (content) {
            const contentObj = JSON.parse(content)
            this.organizedResult = contentObj.organizedResult
            this.auditComment = contentObj.auditComment
          }
          this.showConfirm = true
        }
        $('#' + objectModalName.supplier).modal('show')
      },
      extraActions(data) {
        return `<a class="dropdown-item edit-result" href="#" data-check-id="${data.id}">Prüfergebnis bearbeiten</a>`
      },
      drawCallbackFunctions() {
        const that = this
        $('.download-link').off('click').on('click', function(e) {
          e.preventDefault()
          const url = $(e.target).attr('href')
          window.open(url)
        })
        $('.edit-result').on('click', (e) => {
          e.preventDefault()
          const checkID = $(e.target).data('check-id')
          const result_string = that.toms_list.filter(item => item.id === parseInt(checkID))[0].extra || {}
          if (result_string) {
            that.$router.push({
              name: 'toms', params: {
                surveyResult: JSON.parse(result_string),
              }
            })
          }
        })
      },
      async getTOMs() {
        const that = this
        service.request({
          url: `todos/v1/toms/${this.accountid}/`,
          method: 'GET',
          responseType: 'json'
        }).then(function(response) {
          that.toms_list = response.data
          // that.table = $('.datatable').DataTable({
          //   "data": that.av_list,
          //   "oLanguage": {
          //     "oPaginate": { "sPrevious": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>', "sNext": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>' },
          //     "sInfo": "Seite _PAGE_ von _PAGES_",
          //     "sSearch": '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
          //     "sSearchPlaceholder": "Suche...",
          //     "sLengthMenu": "Einträge per Seite:  _MENU_",
          //   },
          //   responsive: true,
          //   "lengthMenu": [10, 20, 50],
          //   "pageLength": 10,
          //   drawCallback: function () {
          //     $('.t-dot').tooltip({ template: '<div class="tooltip status" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>' })
          //     $('.av-overview').on('click', (e) => {
          //       e.preventDefault()
          //       const surveyID = $(e.target).data('survey-id')
          //       that.organizedResult = that.av_list.filter(item => item.id === surveyID)[0].sorted_result.organizedResult
          //       that.showConfirm = true
          //     })
          //     $('.edit-result').on('click', (e) => {
          //       e.preventDefault()
          //       const checkID = $(e.target).data('check-id')
          //       const checkItem = that.av_list.filter(item => item.id === parseInt(checkID))[0]
          //       service.request({
          //         url: `survey/v1/survey/${checkItem.survey}/`,
          //         method: 'GET',
          //         responseType: 'json'
          //       }).then(function(response) {
          //         const filenameArray = checkItem.unquoted_report_url.split('\\')
          //         that.$router.push({name: 'avv-content', params: {
          //             surveyID: checkItem.survey,
          //             surveyJson: response.data.body,
          //             partnerName: checkItem.partner_name,
          //             partnerAddress: checkItem.partner_address,
          //             contractName: checkItem.contract_name,
          //             gapInput: checkItem.question ? true : false,
          //             filename: filenameArray[filenameArray.length-1],
          //             auftragsgeber: checkItem.controller_name,
          //             remarks: checkItem.remarks,
          //             partnerID: checkItem.partner,
          //             surveyResult: JSON.parse(checkItem.result_body),
          //           }})
          //       }).catch(function(err) {
          //         console.log(err)
          //       })
          //     })
          //   },
          //   fixedHeader: true,
          //   initComplete: function () {
          //     var api = this.api();
          //
          //     // For each column
          //     api
          //       .columns()
          //       .eq(0)
          //       .each(function (colIdx) {
          //         // Set the header cell to contain the input element
          //         var cell = $('.filters th').eq(
          //           $(api.column(colIdx).header()).index()
          //         );
          //
          //         // On every keypress in this input
          //         $(
          //           'input',
          //           $('.filters th').eq($(api.column(colIdx).header()).index())
          //         )
          //           .off('keyup change')
          //           .on('keyup change', function (e) {
          //             e.stopPropagation();
          //
          //             // Get the search value
          //             $(this).attr('title', $(this).val());
          //             var regexr = '({search})'; //$(this).parents('th').find('select').val();
          //
          //             var cursorPosition = this.selectionStart;
          //             // Search the column for that value
          //             api
          //               .column(colIdx)
          //               .search(
          //                 this.value != ''
          //                   ? regexr.replace('{search}', '(((' + this.value + ')))')
          //                   : '',
          //                 this.value != '',
          //                 this.value == ''
          //               )
          //               .draw();
          //
          //             $(this)
          //               .focus()[0]
          //               .setSelectionRange(cursorPosition, cursorPosition);
          //           });
          //       });
          //
          //     $('.dropdown-menu a.dropdown-column-item').each(function(index, item) {
          //       if (api.column(index).visible() && !$(item).hasClass('selected')) {
          //         $(item).addClass('selected')
          //       } else if (!api.column(index).visible() && $(item).hasClass('selected')) {
          //         $(item).removeClass('selected');
          //       }
          //     })
          //   },
          //   "columns": [
          //     { data: "contract_name", width: "15%" },
          //     { data: "partner_name", width: "15%" },
          //     { data: "unquoted_report_url", render: (data) => `<a download href="${baseURL}/survey/v1/download/?filename=${encodeURIComponent(data)}" target="_blank">${data.split(pathSeparator).at(-1)}</a>`, width: "20%" },
          //     { data: "sorted_result.auditResult", render: (data, type, row) => `<a href="#" class="av-overview" data-survey-id="${row.id}">${data}</a>`, width: "10%" },
          //     { data: "remarks", width: "25%" },
          //     { data: "createdon", width: "10%", render: (data) => typeof data === 'string' ? data.substring(0, 10) : '' },
          //     { data: null, render: function(data) {
          //         var return_html = `
          //         <div class="dropdown dropdown-action">
          //             <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
          //             <div class="dropdown-menu dropdown-menu-right">
          //                 <a class="dropdown-item add-customer" href="#" data-survey-id="${data.id}">Partner als Auftraggeber aufnehmen</a>
          //                 <a class="dropdown-item add-supplier" href="#" data-survey-id="${data.id}">Partner als Auftragnehmer aufnehmen</a>
          //                 <a class="dropdown-item edit-result" href="#" data-check-id="${data.id}">Prüfergebnis bearbeiten</a>
          //             </div>
          //         </div>
          //         `;
          //         return return_html
          //       }, width: "5%" }
          //   ],
          //   columnDefs: [
          //     { width: "150px", targets: 2 },
          //     {className: "text-wrap", targets: "_all"},
          //   ],
          //   buttons: [
          //     'csv', 'excel', 'pdf'
          //   ],
          //   dom: 'Bfrtip',
          //   retrieve: true,
          // });
        }).catch(function(err) {
          console.log(err)
        })
      },
    }
  }
</script>

<style scoped>
  .overview-table {
    font-family: 'Tahoma', arial, sans-serif;
    border-collapse: collapse;
    border: 1px solid;
    width: 100%;
  }

  .overview-cell {
    text-align: center;
    padding: 8px;
    vertical-align: middle;
    box-sizing: content-box;
    border: 1px solid;
    color: #1f1f1f;
  }
  .ired {
    background-color: red
  }
  .igreen {
    background-color: green
  }
</style>
